module.exports = __webpack_public_path__ + "img/audioIcon.59a6d4d4.png";